// Global fallback for failed queries in the admin panel. Most dashboards read
// `data = []` / `stats?.x ?? 0`, so a failed query rendered as an empty list
// or "R$ 0" with no hint anything went wrong. Public pages render their own
// LoadErrorState, so the toast is admin-only.

/** Current route path, for both BrowserRouter and HashRouter (VITE_USE_HASH). */
export function currentRoutePath(loc: Pick<Location, "pathname" | "hash">): string {
  return loc.hash.startsWith("#/") ? loc.hash.slice(1) : loc.pathname;
}

export function shouldToastQueryError(routePath: string, meta?: Record<string, unknown>): boolean {
  if (meta?.silentError) return false;
  return routePath === "/admin" || routePath.startsWith("/admin/");
}

export const QUERY_ERROR_TOAST_ID = "query-error";
export const QUERY_ERROR_MESSAGE =
  "Não foi possível carregar parte dos dados. Números e listas podem estar incompletos — recarregue a página.";
